export class Rut {
  constructor(private readonly rut: string) {}

  get clean() {
    return this.rut.replaceAll('.', '').replaceAll('-', '').replaceAll('_', '').replaceAll(/\s/g, '').toUpperCase()
  }

  get hasValidChars() {
    return /^\d+[\dK]$/.test(this.clean)
  }

  get hasValidLength() {
    return this.clean.length >= 8 && this.clean.length <= 9
  }

  get isComplete() {
    return this.hasValidLength && this.hasValidChars
  }

  get isValidFormat() {
    const RUT_REGEX = /^(\d{1,2}\.\d{3}\.\d{3}-[0-9K])$/
    return RUT_REGEX.test(this.format())
  }

  format() {
    const clean = this.clean
    if (clean.length < 2) return clean
    const corpo = clean.slice(0, -1)
    const dv = clean.slice(-1)
    const corpoFormatado = corpo
      .split('')
      .reverse()
      .reduce((acc, digit, index) => {
        const separator = index > 0 && index % 3 === 0 ? '.' : ''
        return digit + separator + acc
      }, '')
    return `${corpoFormatado}-${dv}`
  }
}
